import React from "react";
import CategoryPage from "./CategoryPage";

function Science({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Science & Technology"
      parentCategory="Articles"
      subcategoryValues={[
        "Science",
        "Science & Technology"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default Science;